import React from 'react';

import { Portal } from '../../utils/Portal';

import ErrorsBox, { ValidationErrors } from './ErrorsBox';
import SuccessBox from './SuccessBox';

import Loader from 'components/loader/Loader';

type Props = Readonly<{ isLoading?: boolean; errors?: ValidationErrors; message?: React.ReactNode }>;

function InfoBox({ isLoading = false, errors, message }: Props) {
    if (isLoading) {
        return (
            <Portal id="info-box">
                <Loader isLoading elementToShow />
            </Portal>
        );
    }

    return (
        <>
            {errors && (
                <Portal id="error-box">
                    <ErrorsBox errors={errors} />
                </Portal>
            )}
            {message && (
                <Portal id="info-box">
                    <SuccessBox message={message} />
                </Portal>
            )}
        </>
    );
}

export default InfoBox;
